<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <h4 class="text-center">Gestión de Afiliaciones</h4>
          <hr class="horizontal dark" />
          <h6 class="mt-1">Busca al Afiliado</h6>
          <div class="row">
            <div class="col-">
              <label style="font-weight: 400;">
                Ingresa los datos y realiza tu busqueda
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Nombres</label>
              <input type="text" v-model="nombres" class="form-control">
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Apellidos</label>
              <input type="text" v-model="apellidos" class="form-control">
            </div>
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Número de Certificado</label>
              <input type="text" v-model="numeroCertificado" class="form-control">
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Documento de Identidad</label>
              <input type="text" v-model="documentoIdentidad" class="form-control">
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Estado</label>
              <vue-select
                :options="statusOptions"
                label="text"
                v-model="estado"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-2">
              <button class="btn btn-addiuva-dark w-100" style="margin-top:30px;" @click="searchAfiliados">
                <i class="fas fa-search pr-1"></i> &nbsp; Buscar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div class="row p-2">
          <Toast />
          <DataTable :value="afiliaciones" stripedRows paginator :rows="5" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay afiliaciones que mostrar. </center></template>
            <Column field="nroCertificado" header="Número de Certificado" sortable style="width: 15%"></Column>
            <Column field="programa" header="Programa" sortable style="width: 14%"></Column>
            <Column field="nombreAfiliado" header="Afiliado" sortable style="width: 24%"></Column>
            <Column field="afiliado.documento" header="Documento de Identidad" sortable style="width: 15%"></Column>
            <Column field="inicioVigencia" header="Fecha Inicio" sortable style="width: 10%"></Column>
            <Column field="finVigencia" header="Fecha Fin" sortable style="width: 10%"></Column>
            <Column field="tarifa" header="Tarifa" sortable style="width: 8%"></Column>
            <Column field="estado" header="Estado" sortable style="width:5%; min-width: 2rem">
                <template #body="{ data }">
                    <Tag :value="this.capitalize(data.estado)" :severity="getSeverity(data.estado)" rounded/>
                </template>
            </Column>
            <Column field="company" header="Acción" style="width: 5%">
              <template #body="{ data }">
                <SplitButton label="Acciones" icon="fas fa-ellipsis-h" :model="data.items" menuButtonIcon="fas fa-ellipsis-h"  text v-if="data.items.length > 0" />
              </template>
            </Column>
          </DataTable>
          <!-- Modal Dialogs -->
          <!-- Anulación -->
          <Dialog v-model:visible="anular.visible" modal header="Header" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <template #header>
                <div class="inline-flex align-items-center justify-content-center gap-2">
                  <h5 class="text-bold white-space-nowrap text-danger">ANULAR AFILIACIÓN</h5>
                </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                Esta seguro de Anular el certificado <b>{{anular.nroCertificado}}</b> del afiliado <b>{{anular.nombreAfiliado}}</b><br>
                <small>Si existe algun motivo en particular favor indiquelo a continuación</small>
              </div>
              <div class="col-md-12 mt-2">
                <label class="form-control-label">Motivo de la Anulación </label>
                <textarea v-model="anular.motivo" rows="2" class="form-control" />
              </div>
            </div>
            <template #footer>
                <!-- <Button label="Ok" icon="pi pi-check" @click="visible = false" autofocus /> -->
              <button class="btn btn-light" style="margin-right:1rem;" @click="closeModalAnular()">
                <i class="fas fa-times pr-1"></i> Cancelar
              </button>
              <button class="btn btn-addiuva-dark" @click="anularAfiliacion">
                <i class="fas fa-ban pr-1"></i> Anular
              </button>
            </template>
          </Dialog>
          <!-- Edición -->
          <Dialog v-model:visible="editar.visible" modal header="Header" :style="{ width: '65%' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <template #header>
                <div class="inline-flex align-items-center justify-content-center gap-2">
                  <h5 class="text-bold white-space-nowrap text-addiuva-dark" id="title-edit">EDITAR DATOS DE LA AFILIACIÓN</h5>
                  <small id="title-edit-help">Solo se pueden editar información específica del afiliado</small>
                </div>
            </template>
            <div class="row">
              <div class="col-md-6">
                <detalle-programa
                  :programa = "editar.programa"
                  :periodicidad = "editar.periodicidad"
                  :inicio = "editar.vigencia.inicio"
                  :fin = "editar.vigencia.fin"
                  :tarifa = "editar.tarifa"
                ></detalle-programa>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <label for="nombres">Nombres <span class="text-danger">*</span></label>
                    <InputText id="nombres" class="form-control" v-model="editar.nombres"/>
                  </div>
                  <div class="col-md-12">
                    <label for="apellidos">Apellidos <span class="text-danger">*</span></label>
                    <InputText id="apellidos" class="form-control" v-model="editar.apellidos"/>
                  </div>
                  <div class="col-md-3">
                    <label for="edad">Edad</label>
                    <InputText id="edad" class="form-control" v-model="editar.edad" disabled/>
                  </div>
                  <div class="col-md-9">
                    <label for="documento">Documento <span class="text-danger">*</span></label>
                    <InputText id="documento" class="form-control" v-model="editar.documento"/>
                  </div>
                  <div class="col-md-6">
                    <label for="telefono">Teléfono <span class="text-danger">*</span></label>
                    <InputNumber v-model="editar.telefono" id="telefono" :useGrouping="false" class="w-100"/>
                  </div>
                  <div class="col-md-6">
                    <label for="email">Email <span class="text-danger">*</span></label>
                    <InputText id="email" class="form-control" v-model="editar.email"/>
                  </div>
                </div>
              </div>
            </div>
            <template #footer>
              <button class="btn btn-light" style="margin-right:1rem;" @click="closeModalEditar()">
                <i class="fas fa-times pr-1"></i> Cancelar
              </button>
              <button class="btn btn-addiuva-dark" @click="editarAfiliacion">
                <i class="fas fa-pen pr-1"></i> Editar
              </button>
            </template>
          </Dialog>
          <!-- Restauración -->
          <Dialog v-model:visible="restaurar.visible" modal header="Header" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <template #header>
                <div class="inline-flex align-items-center justify-content-center gap-2">
                  <h5 class="text-bold white-space-nowrap text-addiuva">RESTAURAR AFILIACIÓN</h5>
                </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                Esta seguro de Restaurar el certificado <b>{{restaurar.nroCertificado}}</b> del afiliado <b>{{restaurar.nombreAfiliado}}</b><br>
              </div>
            </div>
            <template #footer>
                <!-- <Button label="Ok" icon="pi pi-check" @click="visible = false" autofocus /> -->
              <button class="btn btn-light" style="margin-right:1rem;" @click="closeModalRestaurar()">
                <i class="fas fa-times pr-1"></i> Cancelar
              </button>
              <button class="btn btn-addiuva-dark" @click="restaurarAfiliacion">
                <i class="fas fa-undo-alt pr-1"></i> Restaurar
              </button>
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import VueSelect from "vue-select";
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import SplitButton from 'primevue/splitbutton';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import DetallePrograma from "./components/DetallePrograma.vue";
import axios from 'axios';
import authHeader from '../services/auth-header';
import moment from "moment"
export default {
  name: "Gestionar Afiliaciones",
  components: {
    VueSelect,
    DataTable,
    Column,
    Tag,
    Toast,
    SplitButton,
    Dialog,
    InputText,
    InputNumber,
    DetallePrograma
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      nombres: null,
      apellidos: null,
      numeroCertificado: null,
      documentoIdentidad: null,
      estado: null,
      statusOptions: [
        {
          text: 'Vigente',
          value: 'VIGENTE'
        },
        {
          text: 'En Mora',
          value: 'MORA'
        },
        {
          text: 'Anulado',
          value: 'ANULADO'
        }
      ],
      showProfileDropdown: false,
      afiliaciones: [],
      anular: {
        visible: false,
        id: null,
        nroCertificado: null,
        nombreAfiliado: null,
        motivo: null
      },
      editar: {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        edad: null,
        documento: null,
        telefono: null,
        email: null,
        programa: null,
        periodicidad: null,
        vigencia: {
          inicio: null,
          fin: null
        },
        tarifa: null
      },
      restaurar: {
        visible: false,
        id: null,
        nroCertificado: null,
        nombreAfiliado: null
      }
    };
  },
  methods: {
    searchAfiliados() {
      this.afiliaciones = [];
      let payload = {
        "nombres": this.nombres,
        "apellidos": this.apellidos,
        "numero_certificado": this.nroCertificado,
        "numero_documento": this.documentoIdentidad,
        "estado": this.estado,
      }
      // Send Data by Axios
      let url = this.API_URL + "/afiliado/buscar";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let afiliaciones = [];
            data.forEach(a => {
              afiliaciones.push({
                id: a.id_afiliacion ?? '',
                nombreAfiliado: a.nombre_afiliado ?? '',
                nroCertificado: a.numero_certificado ?? '',
                inicioVigencia: a.inicio_vigencia ?? '',
                finVigencia: a.fin_vigencia ?? '',
                programa:  a.programa ?? '',
                periodicidad: a.periodicidad ?? '',
                tarifa: a.tarifa ?? '',
                estado: a.estado ?? '',
                fechaActual: a.fecha_actual ?? '',
                fechaEmision: a.fecha_emision ?? '',
                fechaAnulacion: a.fecha_anulacion ?? '',
                afiliado: {
                  idAfiliado: a.afiliado.id_afiliado ?? '',
                  nombres: a.afiliado.nombres ?? '',
                  apellidos: a.afiliado.apellidos ?? '',
                  edad: a.afiliado.edad ?? '',
                  documento: a.afiliado.documento ?? '',
                  telefono: a.afiliado.telefono ?? '',
                  email: a.afiliado.email ?? '',
                }
              });
            });
            afiliaciones.forEach(afiliado => {
              afiliado.tarifa = (afiliado.tarifa != '') ? 'Bs. '+ afiliado.tarifa : '';
              afiliado.items = this.subMenuDefault(afiliado);
              if (afiliado.estado == 'ANULADO') {
                afiliado.items = this.subMenuAnulado(afiliado);
              }
            });
            this.afiliaciones = afiliaciones;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    subMenuDefault(data) {
      let items = [];
      let today = data.fechaActual;
      if (this.differenceBetweenDates(data.fechaEmision, today) <= 7){
        items.push({
          label: 'Editar',
          icon: 'fas fa-pen',
          command: () => {
              this.iniciarEdicion(data)
          }
        });
      }
      items.push({
        label: 'Anular',
        icon: 'fas fa-ban',
        command: () => {
            this.iniciarAnulacion(data);
        }
      });
      return items;
    },
    subMenuAnulado(data) {
      let items = [];
      let today = data.fechaActual;
      if (this.differenceBetweenDates(data.fechaAnulacion, today) <= 2){
        items.push({
          label: 'Restaurar',
          icon: 'fas fa-undo-alt',
          command: () => {
              this.iniciarRestauracion(data)
          }
        });
      }
      return items;
    },
    getSeverity(status) {
      let severity = null;
      if (status == "ANULADO") severity = "danger";
      if (status == "VIGENTE") severity = "success";
      if (status == "MORA") severity = "warning";
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    toggleSubmenu(event) {
      this.$refs.submenu.toggle(event);
    },
    // Anulacion
    iniciarAnulacion(data) {
        this.anular.visible = true,
        this.anular.id = data.afiliado.idAfiliado
        this.anular.nroCertificado = data.nroCertificado
        this.anular.nombreAfiliado = data.nombreAfiliado
        // this.anular.motivo = this.anular.motivo
    },
    closeModalAnular() {
      this.anular = {
        visible: false,
        id: null,
        nroCertificado: null,
        nombreAfiliado: null,
        motivo: null
      };
    },
    anularAfiliacion() {
      if (this.anular.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "id_afiliado": this.anular.id,
        "motivo_anulacion": this.anular.motivo
      }
      // Send Data by Axios
      let url = this.API_URL + "/afiliado/anular";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La anulación fue procesada exitosamente', life: 3000 });
            this.closeModalAnular();
            this.searchAfiliados();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });

    },
    // Edicion
    iniciarEdicion(data) {
      this.editar = {
        visible: true,
        id: data.afiliado.idAfiliado,
        nombres: data.afiliado.nombres,
        apellidos: data.afiliado.apellidos,
        edad: data.afiliado.edad,
        documento: data.afiliado.documento,
        telefono: data.afiliado.telefono,
        email: data.afiliado.email,
        programa: data.programa,
        periodicidad: data.periodicidad,
        vigencia: {
          inicio: data.inicioVigencia,
          fin: data.finVigencia
        },
        tarifa: data.tarifa
      };
    },
    closeModalEditar() {
      this.editar = {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        edad: null,
        documento: null,
        telefono: null,
        email: null,
        programa: null,
        periodicidad: null,
        vigencia: {
          inicio: null,
          fin: null
        },
        tarifa: null
      };
    },
    editarAfiliacion() {
      if (this.editar.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "id_afiliado": this.editar.id,
        "nombres": this.editar.nombres,
        "apellidos": this.editar.apellidos,
        "numero_documento": this.editar.documento,
        "telefono": this.editar.telefono.toString(),
        "email": this.editar.email
      }
      // Send Data by Axios
      let url = this.API_URL + "/afiliado/editar";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La Edición fue procesada exitosamente', life: 3000 });
            this.closeModalEditar();
            this.searchAfiliados();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Restauración
    iniciarRestauracion(data) {
      this.restaurar = {
        visible: true,
        id: data.afiliado.idAfiliado,
        nroCertificado: data.nroCertificado,
        nombreAfiliado: data.nombreAfiliado
      }
    },
    closeModalRestaurar() {
      this.restaurar = {
        visible: false,
        id: null,
        nroCertificado: null,
        nombreAfiliado: null
      };
    },
    restaurarAfiliacion() {
      if (this.restaurar.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "id_afiliado": this.restaurar.id
      }
      // Send Data by Axios
      let url = this.API_URL + "/afiliado/restaurar";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La Restauración fue procesada exitosamente', life: 3000 });
            this.closeModalRestaurar();
            this.searchAfiliados();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    differenceBetweenDates(first, second) {
      var fecha1 = moment(first, "DD/MM/YYYY");
      var fecha2 = moment(second, "DD/MM/YYYY");
      return fecha2.diff(fecha1, 'days');
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Dashboard'});
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
    // this.searchAfiliados()
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
</style>